import { Button, Modal } from 'slab'

export const UnsavedChangesModal = (
  { open, onClose, onDismissChanges, onSaveChanges }:
  { open: boolean, onClose: () => void, onDismissChanges: () => void, onSaveChanges: () => void }
) => {
  return (
    <Modal open={open} onOpenChange={onClose}>
      <Modal.Body>
        <Modal.Title>Unsaved changes</Modal.Title>
        <Modal.Description>You have made changes to your allowance structure. Before going back to explore mode, please save or dismiss your changes.</Modal.Description>
        <Modal.Footer>
          <div className='flex justify-end gap-2'>
            <Button variant='secondary' onClick={onDismissChanges}>Discard changes</Button>
            <Button variant='primary' onClick={onSaveChanges}>Save edits</Button>
          </div>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  )
}
